import styled from '@emotion/styled/macro';

import { PageRootColumns } from '../../../../styledComponents/Page/Page';

export const StyledPageRootColumns = styled(PageRootColumns)`
  margin: 1.5rem 2.5rem;
`;
